import React, { Component } from 'react'
import PageLayout from '../pagelayout';
import StoreMap from "./storemap"
import StoreCount from './storecount';

export default class StoreBooking extends Component {
    render() {
        return (
            <PageLayout bgWhite bgImage Map={StoreMap}>
                <StoreCount/>
            </PageLayout>
        )
    }
}
